import { getRecentSearches, RECENT_SEARCH_KEY } from '@atlassian/search-common';

import { type PrimaryProductKey } from '../../../../common/constants/products';

export const getRecentQueries = (primaryProduct: PrimaryProductKey, userId: string) => {
	return getRecentSearches(userId, primaryProduct, RECENT_SEARCH_KEY);
};
